var exports = {
  "k": "xdde3148b--e529f4--container",
};

module.exports = exports;
